require('dotenv').config();

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYandexMetrika from 'vue-yandex-metrika'
import vClickOutside from 'v-click-outside'
import Vuex from 'vuex'
// Plugins
import Multiselect from 'vue-multiselect'
import ToggleButton from 'vue-js-toggle-button'

import App from './App'
import Http from './API/index'
import Storage from './Store/Store'
import Global from './Global'
import SideBar from './components/UIComponents/Plugins/SidebarPlugin'
import ScaleLoader from 'vue-spinner/src/ScaleLoader'
import Notifications from './components/UIComponents/Plugins/NotificationPlugin'

import * as VueGoogleMaps from 'vue2-google-maps'

// router setup
import routes from './routes/routes'
import access from './routes/access'

import VModal from 'vue-js-modal'
// library imports
import 'es6-promise/auto'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/paper-dashboard.scss'
// translate
import translate from './translate'

import Clipboard from './components/UIComponents/services/clipboard'
import MultiLanguage from 'vue-multilanguage'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Vuex)
Vue.use(SideBar)
Vue.use(VueRouter)
Vue.use(Multiselect)
Vue.use(ToggleButton)
Vue.use(vClickOutside)
Vue.use(Notifications)
Vue.use(Global)
Vue.use(VModal, { dialog: true, dynamic: true, adaptive: true, clickToClose: true, scrollable: true })

Vue.component('scale-loader', ScaleLoader)

const store = new Vuex.Store({
  modules: Storage
})
// configure router

const router = new VueRouter({
  routes: routes.MyRoute.def(),
  mode: 'history',
  linkActiveClass: 'active'
})

Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return this.$root.http
  }
})

Object.defineProperty(Vue.prototype, '$routers', {
  get () {
    return this.$root.routers
  }
})

Object.defineProperty(Vue.prototype, '$clipboard', {
  get () {
    return new Clipboard(this)
  }
})

Object.defineProperty(Vue.prototype, 'localStorage', {
  get () {
    return window.localStorage
  }
})

Vue.use(MultiLanguage, translate)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  computed: {
    auth () { return this.$store.getters.getAuth },
    document_title () {
      return this.$store.state.main.other_title ? this.$store.state.main.other_title : this.$store.state.main.main_title
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    load_page () {
      return this.$store.getters.getLoadPage
    }
  },
  data: {
    http: Http,
    routers: null,
    loading: true,
    access: access,
    attribute: { name_company: 'Sistematics', company_url: 'https://sistematics.ru'}
  },
  render: h => h(App, { props: { loading: true } }),
  beforeMount () {
    setInterval(() => {
      if (document.visibilityState === 'hidden') {
        this.$store.commit('updateVisibilityState', false)
      }else{
        this.$store.commit('updateVisibilityState', true)
      }
    }, this.$store.getters.getCountdown)

    this.http.v1.getProps((response)=> {
      this.attribute.name_company = response.data.company;
      this.attribute.company_url =  response.data.company_url;
      response.data.title ? this.$store.commit('updateMainTitle', response.data.title) : '';
      this.$store.commit('updateDatetimePicker', response.data.datetime_picker_period_days)
      this.$store.commit('updateVersionMonitoringFront', response.data.version)

      let yandex_metric_id = response.data.yandex_metric_id ? response.data.yandex_metric_id : process.env.VUE_APP_YANDEX_MATRIC_ID
      let google_maps_key = response.data.google_maps_key ? response.data.google_maps_key : process.env.VUE_APP_GOOGLE_MAPS_KEY

      Vue.use(VueYandexMetrika, {
        id: yandex_metric_id,
        router: router,
        env: process.env.NODE_ENV
      })

      Vue.use(VueGoogleMaps, {
        load: {
          key: google_maps_key,
          libraries: 'places'
        }
      })
    })

    // for (let script of document.scripts) {
    //   console.log(script.src);
    // }
    //
    // console.log(document.location.origin)

    this.getStatusUser()

    this.http.v1.bad_answer = this.http.simcard.bad_answer = (response) => {
      if (response.status === 401) {
        this.$store.commit('updateAuth', false)
        if (this.localStorage.getItem('auth') !== null) {
          this.global_notify('danger', this.translate('http.session_failed'))
        }
        this.localStorage.removeItem('auth')
        if (this.$route.path !== '/auth') {
          this.localStorage.setItem('path', this.$route.path)
        }
        this.$store.commit('logout')
      } else if (response.status === 403) {
        this.global_notify('danger', this.translate('http.access_denied'))
      } else {
        this.bad_answer_handler(response)
      }
    }

    this.$router.beforeResolve((to, from, next) => {
      if (to.path === '/auth' || to.path === '/notfound'){
        next()
      }else if (access.prove(this.permissions, to.name, to.params)) {
        next()
      } else {
        next('/notfound')
      }
    })
  },
  methods: {
    getStatusUser () {
      if (this.localStorage.getItem('auth') !== null) {
        this.$http.v1.getUserStatus((resp) => {
          this.$store.commit('updateAuth', true)
          this.$store.commit('updateUser', resp.data.user)

          this.$store.commit('updateSelfTestServer', resp.data.selftest_server)
          this.$store.commit('setGlobalTiming', resp.data.front_timers)
          this.$store.commit('updateModules', resp.data.monitoring_modules)
          this.$store.commit('updateCommentsFilters', resp.data.comments_filter)

        }, () => {
          this.localStorage.removeItem('auth')
          this.$store.commit('updateAuth', false)
        })
        this.$store.commit('setDeviceFilter', JSON.parse(this.localStorage.getItem('filter_devices')))
        this.$store.commit('setSimcardDevicesFilter', JSON.parse(this.localStorage.getItem('filter_simcard_devices')))
        this.$store.commit('setSimcardProfileFilter', JSON.parse(this.localStorage.getItem('filter_simcard_profile')))
      } else {
        this.$store.commit('updateAuth', false)
      }
    },
    UpdateRoutes(){
      let timer = setInterval(() => {
        if (Object.keys(this.$store.getters.getPermissions).length > 0) {
          clearInterval(timer)
          this.$router.addRoute(routes.MyRoute.user());
        }
      }, 10)
    },
  },
  watch: {
    $route(){
      if (this.$route.hash.indexOf('#') !== -1){
        this.$router.push(this.$route.hash.replace('#', ''))
      }
    },
    document_title () {
      Vue.nextTick(() => {
        document.title = this.document_title;
      });
    },
    auth: {
      handler(new_val, old_val){
        if (this.auth !== true) {
          if (this.$router.currentRoute.path !== '/auth') {
            if (this.localStorage.getItem('logout') !== '1') {
              this.localStorage.setItem('path', this.$route.path)
            }
            this.$router.push('/auth')
          }
        } else {
          this.$store.dispatch('startPreload')
          this.UpdateRoutes() // обновляем доступные разделы
        }

        if (new_val === true && old_val === false) {  //Возможно, можно сделать лучше
          this.timer = setInterval(() => {
            if (Object.keys(this.$store.getters.getPermissions).length > 0) {
              if (this.localStorage.getItem('path')) {
                let path = this.localStorage.getItem('path')
                this.localStorage.setItem('path', '')
                this.$router.push(path)
              } else {
                if (this.$store.getters.getPermissions.viewDashboard) {
                  this.$router.push('/dashboard')
                }else{
                  this.$router.push('/')
                }
              }
              clearInterval(this.timer)
            }
          }, 10)
        }




        // Данный блок кода проверяет предыдущее состояние переменной auth, и сравнивает с новым.
        // При смене состояния c false на true идёт отслеживание permissions и в зависимости от них,
        // нас отправляет на стартовую страницу /device_list или /dashboard
      }
    },

    this_route () {
      this.$modal.hide('dynamic-modal')
    },
  }
})